import { apiClient } from '@/shared/api/apiClient';
import { handleRequest } from '@/shared/api/apiWrapper';
import type {
  CommissionDepositOperationParams,
  CreateDepositOperationParams,
  DepositCreateOperationType,
} from '@/shared/types';
import { objectToQueryParamsStr } from '@/shared/utils';

export const createDepositOperation = async <TResponse>(
  operationType: DepositCreateOperationType,
  data: CreateDepositOperationParams
): Promise<TResponse> => {
  const request = () =>
    apiClient.post(`/operations/${operationType}/deposit`, data);
  const response = await handleRequest(request);

  return response.data;
};

export const getOperationDepositCommission = async <
  TResponse,
  TParams extends Record<string, string | number> &
    object = CommissionDepositOperationParams,
>(
  type: DepositCreateOperationType,
  params: TParams
): Promise<TResponse> => {
  const request = () => {
    const queryParams = objectToQueryParamsStr(params);

    return apiClient.get(
      `/operations/${type}/deposit/commission?${queryParams}`
    );
  };

  const response = await handleRequest(request);

  return response.data;
};
